import { Action } from '@ngrx/store';
import { JobListing } from '../models/listing.model';

export enum ListingActionTypes {
  LoadListing = '[Listing] Load Listing',
  LoadListingSuccess = '[Listing] Load Listing Success',
  LoadListingFail = '[Listing] Load Listing Fail',
  UseListing = '[Listing] Temporary action - use listing from another service',
  SaveListing = '[Listing] Save Listing',
  SaveListingSuccess = '[Listing] Save Listing Success',
  ListingActionFail = '[Listing] Listing Action Fail',
  DeleteListing = '[Listing] Delete Listing',
  DeleteListingSuccess = '[Listing] Delete Listing Success',
}

export class LoadListing implements Action {
  readonly type = ListingActionTypes.LoadListing;
  constructor(public payload: { jobId: string }) {}
}

export class LoadListingSuccess implements Action {
  readonly type = ListingActionTypes.LoadListingSuccess;
  constructor(public payload: { listing: JobListing }) {}
}

export class LoadListingFail implements Action {
  readonly type = ListingActionTypes.LoadListingFail;
  constructor(public payload: { error: any }) {}
}

export class UseListing implements Action {
  readonly type = ListingActionTypes.UseListing;
  constructor(public payload: { listing: JobListing }) {}
}

export class SaveListing implements Action {
  readonly type = ListingActionTypes.SaveListing;
  constructor(
    public payload: {
      listing: JobListing;
      jobId: number;
    }
  ) {}
}

export class SaveListingSuccess implements Action {
  readonly type = ListingActionTypes.SaveListingSuccess;
  constructor(public payload: { listing: JobListing }) {}
}

export class ListingActionFail implements Action {
  readonly type = ListingActionTypes.ListingActionFail;
  constructor(public payload: { error: any }) {}
}

export class DeleteListing implements Action {
  readonly type = ListingActionTypes.DeleteListing;
  constructor(public payload: { listingId: number }) {}
}

export class DeleteListingSuccess implements Action {
  readonly type = ListingActionTypes.DeleteListingSuccess;
}

export type ListingActions =
  | LoadListing
  | LoadListingSuccess
  | LoadListingFail
  | UseListing
  | SaveListing
  | SaveListingSuccess
  | ListingActionFail
  | DeleteListing
  | DeleteListingSuccess;
